"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StyledThrobber = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var Throbber = /*#__PURE__*/_react["default"].memo(function (props) {
  var _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className,
    _props$size = props.size,
    size = _props$size === void 0 ? 50 : _props$size,
    _props$thickness = props.thickness,
    thickness = _props$thickness === void 0 ? 2 : _props$thickness,
    _props$color = props.color,
    color = _props$color === void 0 ? '' : _props$color,
    _props$embed = props.embed,
    embed = _props$embed === void 0 ? false : _props$embed;
  return /*#__PURE__*/_react["default"].createElement(StyledThrobber, {
    className: className,
    size: size,
    thickness: thickness,
    color: color,
    embed: embed
  });
});
Throbber.displayName = 'Throbber';
var spin = (0, _styledComponents.keyframes)(["from{transform:rotate(0deg);}to{transform:rotate(360deg);}"]);
var StyledThrobber = exports.StyledThrobber = _styledComponents["default"].div.withConfig({
  displayName: "Throbber__StyledThrobber",
  componentId: "sc-1bntrqf-0"
})(["width:100%;height:100%;margin:0 auto;display:block;top:0;left:0;", " ::before{width:", ";height:", ";content:'';position:absolute;border-radius:100%;top:calc(50% - ", ");left:calc(50% - ", ");border:solid;border-width:", ";border-color:", ";border-left-color:rgba(255,255,255,0.3);border-bottom-color:rgba(255,255,255,0.3);animation:", " 0.5s linear infinite;}"], function (props) {
  return "".concat(props.embed ? "position: relative;" : "position: absolute;");
}, function (props) {
  return "".concat(props.size, "px");
}, function (props) {
  return "".concat(props.size, "px");
}, function (_ref) {
  var size = _ref.size,
    thickness = _ref.thickness;
  return "".concat(size / 2 + thickness, "px");
}, function (_ref2) {
  var size = _ref2.size;
  return "".concat(size / 2, "px");
}, function (props) {
  return "".concat(props.thickness, "px");
}, function (props) {
  return props.color ? props.theme.colors[props.color] || props.color : props.theme.colors.white;
}, spin);
var _default = exports["default"] = Throbber;